<template>
    <Breadcrumbs main="Form Widgets" title="Clipboard" />
    <div class="container-fluid">
        <div class="row">
            <textInput />
            <textArea />
            <paraGraph />
            <copyPortion />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const textInput = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/clipboard/textInput.vue"))
const textArea = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/clipboard/textArea.vue"))
const paraGraph = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/clipboard/paraGraph.vue"))
const copyPortion = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/clipboard/copyPortion.vue"))
</script>